// 摄像头socket
import SockJS from "sockjs-client";
import Stomp from "stompjs";
const url = "https://iot.joylive.com/joycloud-pop/websocket";
// const url = "http://106.14.36.215:31021/websocket";
var socket = null;
var elevators = "";
var currentEle = "";
var global_callback = null;
export default {
  sendSock(agentData, callback) {
    console.log("camera");
    // agentData=>socket所需参数 callback=>回调函数
    if (agentData.length > 0) {
      elevators = agentData.map(item => {
        if (item.ipcDeviceSerial) {
          return item.ipcDeviceSerial
        }
      }).join(',');
      if (JSON.stringify(agentData) != JSON.stringify(currentEle)) {
        currentEle = agentData;
        global_callback = callback;
        // setTimeout(() => {
          this.initSocket();
        // },500)

      }

    }
  },
  closeSocket() {
    global_callback = null;
    if (socket && socket.readyState === 1) {
      socket.close();
      socket = null;
    }
  },
  initSocket() {
    var that = this;
    var sockjs = new SockJS(url);
    var stompClient = Stomp.over(sockjs);
    stompClient.heartbeat.outgoing = 20000;
    stompClient.heartbeat.imcoming = 10000;
    var header = {
      "Authorization": localStorage.getItem("token"),
    }
    stompClient.connect(header, function connectCallback(frame) {
      stompClient.subscribe(`/camera/${localStorage.getItem('username')}`, (rs) => {
        that.fillValueCamera(JSON.parse(rs.body))
      });
      stompClient.send("/subscribeDevice", header,
        JSON.stringify({ "devList": elevators }))
    }, function errorCallBack(error) {
    });
  },
  fillValueCamera(data) {
    //智能硬件注册码， elevatorCode
    this.setCameraData(data);
  },
  setCameraData(data) {
    currentEle.forEach((el) => {
      el.runImg = this.runCameraImgFunc(data);
      // && !el.flagType
      if (el.ipcDeviceSerial == data.devid && !el.flagType) {
        el.floor = data.elevstatus.elevnum;
      }
      if(!el.flagType){
        if (data.elevstatus.elevactpos < 0 && el.ipcDeviceSerial == data.devid) {
          el.flow = "";
        } else if (el.ipcDeviceSerial == data.devid) {
          el.flow =
            data.elevstatus.elevactpos == 0 ? "011" : data.Car_Direction == 1 ? "100" : "";
          //运行时间
          el.sysRuntime = (data.acinfo.actime / 3600).toFixed(1);
          //运行次数
          el.runCount = data.acinfo.acelevtimes;
          //速度
          el.runningSpeed = data.elevstatus.speed;
          //气压
          el.runningPress = data.elevstatus.press;
          //人数
          el.runningPersonCount = data.personcount;
          // el.flagType = "camera"
        }
      }else{
        if (data.elevstatus.elevactpos < 0 && el.ipcDeviceSerial == data.devid) {
          el.flow = "";
        } else if (el.ipcDeviceSerial == data.devid) {
          el.flow =
            data.elevstatus.elevactpos == 0 ? "011" : data.Car_Direction == 1 ? "100" : "";
          //运行时间
          // el.sysRuntime = (data.acinfo.actime / 3600).toFixed(1);
          //运行次数
          // el.runCount = data.acinfo.acelevtimes;
          //速度
          el.runningSpeed = data.elevstatus.speed;
          //气压
          el.runningPress = data.elevstatus.press;
          //人数
          el.runningPersonCount = data.personcount;
          // el.flagType = "camera"
  
        }
      }
      
      global_callback(currentEle);
    })

  },
  runCameraImgFunc(data) {
    currentEle.forEach((el) => {
      if (data.dooropen == 0 && el.ipcDeviceSerial == data.devid  && !el.flagType) {
        // 关门
        if (el.runImg && el.runImg.indexOf("open") > -1) {
          return "elevator_big_closing.gif";
        } else {
          return "elevator_big_close.png";
        }
      } else if (data.dooropen == 1 && el.ipcDeviceSerial == data.devid  && !el.flagType) {
        // 开门
        if (el.runImg && el.runImg.indexOf("close") > -1) {
          return "elevator_big_opening.gif";
        } else {
          return "elevator_big_open.png";
        }
      }
    })

  },
};
